import { useQuery } from '@apollo/client/react';
import { useAuth } from '@drycut/auth';
import { type CompleteStoreFragment, GetStoreDocument } from '@drycut/graphql';
import { createContext, type PropsWithChildren, useContext } from 'react';

type StoreContextValue = {
  loading: boolean;
  store: CompleteStoreFragment | null | undefined;
};

const StoreContext = createContext<StoreContextValue>({
  store: null,
  loading: false,
});

export function StoreProvider({ children }: PropsWithChildren): React.ReactElement {
  const { currentSlug } = useAuth();

  const { data, loading } = useQuery(GetStoreDocument, {
    variables: { slug: currentSlug || '' },
  });

  const store = data?.store;

  return <StoreContext.Provider value={{ store, loading }}>{children}</StoreContext.Provider>;
}

export const useStoreContext = () => {
  const { store, loading } = useContext(StoreContext);

  return { store, loading };
};
